/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_OutboundInputs */

const cs_settings_calendar_outbound = /** @type {(inputs: Settings_Calendar_OutboundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportovat moje úkoly do tohoto kalendáře`)
};

const en_settings_calendar_outbound = /** @type {(inputs: Settings_Calendar_OutboundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export my tasks to this calendar`)
};

/**
* | output |
* | --- |
* | "Export my tasks to this calendar" |
*
* @param {Settings_Calendar_OutboundInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_outbound = /** @type {((inputs?: Settings_Calendar_OutboundInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_OutboundInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_outbound(inputs)
	return cs_settings_calendar_outbound(inputs)
});